import { useMemo } from 'react';

const ObfuscatedEmail = ({ color = 'black' }) => {
    const addr = useMemo(() => {
        const parts = ['Mely', 'Maid', 'OC'];
        const domain = ['Gmail', '.com'];
        return parts.join('') + '@' + domain.join('');
    }, []);

    return (
        <a
            href={`ma${''}ilto:${addr}`}
            style={{
                color,
                textDecoration: 'none',
            }}
        >
            {addr}
        </a>
    );
};

export default ObfuscatedEmail;
